module.exports = __webpack_public_path__ + "static/media/konica_minolta.7a2bf8e6.webp";